import type { ReactElement } from 'react'
import cc from 'classcat'

import AccountIcon from '../AccountIcon'
import HeaderLanguageSwitch from '../HeaderLanguageSwitch'
import HeaderLogo from '../HeaderLogo'
import MiniCart from '../MiniCart'
import SearchForm from '../SearchForm'
import ThemeHeaderMenu from '../ThemeHeaderMenu'

type Props = any
export default function OneRowHeader(props: Props): ReactElement {
  const { shop, isPreview, stickyHeaderClass, stickyHeaderRef } = props

  return (
    <div ref={stickyHeaderRef} className={cc(['section site-header', stickyHeaderClass])}>
      <div className="wrapper">
        <header className="header">
          <div className="block left">
            <ThemeHeaderMenu {...props} />
          </div>
          <div className={cc(['header-logo', shop.logoUrl && !shop.shouldHideLogo && 'header-logo-adjustments'])}>
            <HeaderLogo shop={shop} />
          </div>
          <HeaderLanguageSwitch />
          <div className="block right">
            <div className="header-search">
              <SearchForm className="search-form" namespace="header" maxSuggestedItems={5} />
            </div>
            <AccountIcon accountUrl={shop.accountUrl} isPreview={isPreview} />
            <MiniCart cartUrl={shop.cartUrl} />
          </div>
        </header>
      </div>
    </div>
  )
}
